
interface MeetCodySectionProps {
  title?: string;
  description?: string[];
  image?: string;
}

export function MeetCodySection({
  title = "Hey, I'm Cody 👋",
  description = [
    "I've been living in Austin for over 10 years now, and I've been an entrepreneur since I was 14. I'm also the founder of SupportNinja and the host of the MindHack Podcast.",
    "My podcast started because I kept having these fascinating conversations with people and thought, \"This needs to be recorded!\"",
    "Now, I rent out my backyard podcast studio because I want to help others share their messages too.",
    "Whether it's a big idea, a great story, or just something worth saying, I'm here to make sure you have a space to do it!"
  ],
  image = "/lovable-uploads/a61d3852-2e17-4ebc-a4a3-e7dab43389a8.png"
}: MeetCodySectionProps) {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div className="rounded-2xl overflow-hidden shadow-xl order-2 md:order-1">
            <img 
              src={image}
              alt="Portrait of Cody"
              className="w-full h-[400px] object-cover"
            />
          </div>
          <div className="space-y-6 order-1 md:order-2">
            <h2 className="text-4xl font-bold text-studio-stone">{title}</h2>
            <div className="space-y-4 text-lg text-studio-stone/80">
              {description.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
